module.exports = __webpack_public_path__ + "static/media/bw.6c2cdb0c.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/bw.svg
// module id = 613
// module chunks = 0